import React from "react";
import clsx from "clsx";

import styles from "./layout.module.scss";

type FormContentProps = {
	children?: React.ReactNode;
	className?: string;
};

export const FormContent = ({ children, className }: FormContentProps) => {
	return (
		<div className={clsx(styles.formContent, className)}>{children}</div>
	);
};
